module.exports = __webpack_public_path__ + "img/SelfTest.0c962545.svg";